export enum CheckInProcessType {
  meetAndGreet = 'Meet and greet',
  none = 'Go straight to the site',
}

export interface ICheckInProcessType {
  type: 'meetAndGreet' | 'none';
}
